"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.LtUncertainAltComponent = void 0;
require('../lt-uncertain-alt/lt-uncertain-alt.component.css');
var angular = require("angular");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var LtUncertainAltComponent = /** @class */ (function () {
    function LtUncertainAltComponent($rootScope, $scope, $timeout) {
        this.issueConfig = {};
        this.disableEdit = false;
        this.COL_CONSTANTS = {
            DESIRABILITY: "desirability",
            FEASIBILITY: "feasibility",
            VIABILITY: "viability",
            STICKY: "sticky",
            DEFAULT: "default",
            HARD_ST: "hardSt",
            MEDIUM_ST: "mediumSt",
            EASY_ST: "easySt"
        };
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.NONE);
        ctrl.options = { show: true, id: -1 };
        ctrl.$timeout = $timeout;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $scope.$on('command:IMPACT_MAPPING', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.initComponent(event, args);
        });
        $timeout();
    }
    LtUncertainAltComponent.prototype.getHeight = function (issueName, index) {
        if (issueName.length < 15) {
            return '45px';
        }
        else {
            var height = Math.ceil(issueName.length / 10) * 20;
            return height + 'px';
        }
    };
    LtUncertainAltComponent.prototype.onStickyChange = function (id, stickyIndex) {
        var ctrl = this;
        ctrl.updateChangeDate(id, stickyIndex);
        ctrl.saveDFV();
    };
    LtUncertainAltComponent.prototype.checkboxExist = function (stickyData, key) {
        var exist = false;
        try {
            // For potential showstopper case
            if (key == 'pss') {
                exist = stickyData.isPotentialShowStopper;
            }
            else {
                var indexGot = stickyData.impactMappingList.findIndex(function (n) { return n['key'] == key; });
                if (indexGot != -1) {
                    exist = true;
                }
            }
        }
        catch (e) {
        }
        return exist;
    };
    LtUncertainAltComponent.prototype.radioExist = function (stickyData, key) {
        var exist = false;
        try {
            if (stickyData.impactMappingList != this.COL_CONSTANTS.DEFAULT
                && stickyData.impactMappingList.length > 0) {
                if (stickyData.impactMappingList[0].key == key) {
                    exist = true;
                }
            }
        }
        catch (e) { }
        return exist;
    };
    LtUncertainAltComponent.prototype.getNpvSwing = function (display) {
        var ctrl = this;
        var item = ctrl.npvData.find(function (n) { return n.name === display; });
        console.log(item.npvSwing);
        return item.npvSwing;
    };
    LtUncertainAltComponent.prototype.getCalculatedImpact = function (display) {
        var ctrl = this;
        var npvSwing = ctrl.getNpvSwing(display);
        var npvMax = ctrl.npvData[0].npvSwing; // Considering first as max always
        return Math.round((npvSwing / npvMax) * 8.99 + 0.5);
    };
    LtUncertainAltComponent.prototype.getCalculatedImpactCheckbox = function (rangeArr) {
        var ctrl = this;
        var scores = [];
        rangeArr.forEach(function (range) {
            var npvSwing = ctrl.getNpvSwing(range.display);
            var npvMax = ctrl.npvData[0].npvSwing; // Considering first as max always
            var finalScore = Math.round((npvSwing / npvMax) * 8.99 + 0.5);
            scores.push(finalScore);
        });
        return rangeArr.length > 0 ? Math.max.apply(Math, scores) : null;
    };
    LtUncertainAltComponent.prototype.onLtChange = function (id, newOne, display, event) {
        var ctrl = this;
        var newData = {
            "key": newOne,
            "display": display,
            "reason": { "high": '', "low": '' }
        };
        ctrl.issueDetails = ctrl.defaultSt[id];
        if (newOne == 'pss') // potential showstopper
         {
            ctrl.issueDetails.isPotentialShowStopper = !ctrl.issueDetails.isPotentialShowStopper;
            ctrl.checkPotentialAndSave(ctrl);
        }
        else {
            if (ctrl.inputTypeLt == 'radio') {
                if (ctrl.issueDetails.impactMappingList != 'default' &&
                    ctrl.issueDetails.impactMappingList[0]['Key'] == newOne) {
                    ctrl.issueDetails.impactMappingList = ctrl.COL_CONSTANTS.DEFAULT;
                    ctrl.issueDetails.calcImpact = null;
                }
                else {
                    if (ctrl.issueDetails.impactMappingList != 'default' &&
                        newData.key == ctrl.issueDetails.impactMappingList[0].key) {
                        ctrl.issueDetails.impactMappingList = 'default';
                        ctrl.issueDetails.calcImpact = null;
                    }
                    else {
                        // ctrl.issueDetails.impactMappingList = [newData];
                        if (ctrl.issueDetails.impactMappingList == 'default') {
                            ctrl.issueDetails.impactMappingList = [newData];
                        }
                        else {
                            ctrl.issueDetails.impactMappingList[0].key = newData.key;
                            ctrl.issueDetails.impactMappingList[0].display = newData.display;
                        }
                        ctrl.issueDetails.calcImpact = this.getCalculatedImpact(display);
                    }
                }
                ctrl.checkPotentialAndSave(ctrl);
            }
            else if (ctrl.inputTypeLt == 'checkbox') {
                if (!(ctrl.issueDetails.impactMappingList && ctrl.issueDetails.impactMappingList != 'default')) {
                    ctrl.issueDetails.impactMappingList = [];
                }
                var existIndex = ctrl.issueDetails.impactMappingList.findIndex(function (n) { return n.key === newOne; });
                if (existIndex > -1) { //exist
                    ctrl.issueDetails.impactMappingList.splice(existIndex, 1);
                    if (ctrl.issueDetails.impactMappingList.length == 0) {
                        ctrl.issueDetails.impactMappingList = 'default';
                        ctrl.issueDetails.calcImpact = null;
                    }
                    ctrl.checkPotentialAndSave(ctrl);
                }
                else {
                    if (ctrl.issueDetails.impactMappingList.length >= ctrl.multipleImpactLimit && ctrl.issueDetails.showImpactMappingPopUp) {
                        // alert("Length is greater than 2, do you want to assign more?")
                        event.preventDefault();
                        bootbox.dialog({
                            message: "You are mapping the issue <strong>'" + ctrl.issueDetails.name + "'</strong> to more than " + ctrl.multipleImpactLimit + " inputs. Are you sure?",
                            title: "Multiple Inputs Mapping",
                            buttons: {
                                confirm: {
                                    label: "Yes",
                                    className: "btn-success",
                                    callback: function () {
                                        ctrl.onLtSave(ctrl, newData);
                                        ctrl.issueDetails.showImpactMappingPopUp = false;
                                    }
                                },
                                cancel: {
                                    label: "No",
                                    className: "btn-primary"
                                }
                            }
                        });
                    }
                    else {
                        ctrl.onLtSave(ctrl, newData);
                    }
                }
            }
        }
    };
    LtUncertainAltComponent.prototype.onLtSave = function (ctrl, newData) {
        ctrl.issueDetails.impactMappingList.push(newData);
        ctrl.issueDetails.calcImpact = ctrl.getCalculatedImpactCheckbox(ctrl.issueDetails.impactMappingList);
        ctrl.checkPotentialAndSave(ctrl);
        ctrl.$scope.$apply();
    };
    LtUncertainAltComponent.prototype.checkPotentialAndSave = function (ctrl) {
        if (!ctrl.issueDetails.isPotentialShowStopper) {
            ctrl.issueDetails.abilityToLaunch.key = "default";
            ctrl.issueDetails.calcImpact = null;
            if (ctrl.issueDetails.impactMappingList != 'default') {
                ctrl.issueDetails.calcImpact = this.getCalculatedImpactCheckbox(ctrl.issueDetails.impactMappingList);
            }
        }
        else {
            var calcImpactValues = { 'default': 0, 'hardSt': 8, 'mediumSt': 5, 'easySt': 2 };
            if (ctrl.issueDetails.abilityToLaunch.key != 'default') {
                ctrl.issueDetails.calcImpact = ctrl.issueDetails.calcImpact > calcImpactValues[ctrl.issueDetails.abilityToLaunch.key] ?
                    ctrl.issueDetails.calcImpact : calcImpactValues[ctrl.issueDetails.abilityToLaunch.key];
            }
        }
        ctrl.issueDetails.updatedAt = ctrl.utilsService.updatedAt();
        ctrl.saveDFV();
    };
    LtUncertainAltComponent.prototype.getCheckedValue = function (id, keyGot) {
        var ctrl = this;
        ctrl.issueDetails = ctrl.defaultSt[id];
        return ctrl.issueDetails.ltUncertainty == keyGot;
    };
    LtUncertainAltComponent.prototype.updateChangeDate = function (dfv, id) {
        var ctrl = this;
        ctrl.defaultSt[id].updatedAt = ctrl.utilsService.updatedAt();
    };
    // duplicateExists() {
    //     const ctrl = this;
    //     let tmp = [];
    //     if (!ctrl.checkDuplicate(ctrl.defaultSt, tmp)) {
    //         if (!ctrl.checkDuplicate(ctrl.hardSt, tmp)) {
    //             if (!ctrl.checkDuplicate(ctrl.easySt, tmp)) {
    //                 if (!ctrl.checkDuplicate(ctrl.mediumSt, tmp)) {
    //                     return false;
    //                 }
    //             }
    //         }
    //     }
    //     return true;
    // }
    // checkDuplicate(list, tmp) {
    //     const ctrl = this;
    //     for (let i = 0; i < list.length; i++) {
    //         if (tmp.indexOf(list[i]['name']) == -1) {
    //             tmp.push(list[i]['name']);
    //         } else {
    //             ctrl.showAlert('danger', 'Cannot save!', '"' + list[i]['name'] + '" exists more than once!');
    //             return true;
    //         }
    //     }
    //     return false
    // }
    // addSticky() {
    //     const ctrl = this;
    //     ctrl.defaultSt.unshift(
    //         ctrl.utilsService.getNewSticky(),
    //     );
    //     ctrl.saveDFV();
    // }
    //
    // deleteSticky(issueId, list) {
    //     const ctrl = this;
    //     for (let i = 0; i < list.length; i++) {
    //         if (issueId == list[i]._id) {
    //             list.splice(i, 1);
    //             break;
    //         }
    //     }
    //     ctrl.saveDFV();
    // }
    LtUncertainAltComponent.prototype.setHoveredSticky = function (show, id) {
        var ctrl = this;
        ctrl.options = { show: true, id: id };
    };
    LtUncertainAltComponent.prototype.showIcons = function (id) {
        var ctrl = this;
        return ctrl.options.show == true && ctrl.options.id == id;
    };
    LtUncertainAltComponent.prototype.populateItemList = function (dfvType, data) {
        var ctrl = this;
        data.forEach(function (d) {
            d['name'] = d.name ? d.name : d.title;
            d['type'] = dfvType;
            d['color'] = ctrl.issueConfig[dfvType];
            d['showImpactMappingPopUp'] = true;
            // if (d.ltUncertainty == 'default') {
            ctrl.defaultSt.push(d);
            // }
            // ctrl.distInputs.forEach(dist => {
            //         ctrl.allDistsData[dist.key]= ctrl.allDistsData[dist.key] || [] 
            //         if (d.ltUncertainty == dist.key){
            //             ctrl.allDistsData[dist.key].push(d);
            //         }
            //  })
        });
    };
    LtUncertainAltComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.menu = [];
        ctrl.emptyAll();
        ctrl.setLtUncertainData(args.config.data);
    };
    LtUncertainAltComponent.prototype.emptyAll = function () {
        var ctrl = this;
        ctrl.allStickies = [];
        ctrl.easySt = [];
        ctrl.mediumSt = [];
        ctrl.hardSt = [];
        ctrl.defaultSt = [];
        ctrl.distInputs = [];
        ctrl.npvData = [];
        ctrl.headersData = [];
        ctrl.selectedControls = [];
        ctrl.inputTypeLt = "";
    };
    LtUncertainAltComponent.prototype.setLtUncertainData = function (res) {
        var ctrl = this;
        if (res) {
            var resData_1 = res['NColCanvasSwotData'];
            // Specify the keys that you want to move to the last
            var keysToMove_1 = [ctrl.utilsService.issueType.STRENGTHS.NAME,
                ctrl.utilsService.issueType.WEAKNESSES.NAME,
                ctrl.utilsService.issueType.OPPORTUNITIES.NAME,
                ctrl.utilsService.issueType.THREATS.NAME];
            // Create a new object with the desired key order
            var sortedResData_1 = Object.assign.apply(Object, __spreadArray(__spreadArray([{}], Object.keys(resData_1)
                .filter(function (key) { return !keysToMove_1.includes(key); })
                .map(function (key) {
                var _a;
                return (_a = {}, _a[key] = resData_1[key], _a);
            }), false), keysToMove_1.map(function (key) {
                var _a;
                return (_a = {}, _a[key] = resData_1[key], _a);
            }), false));
            // ctrl.distInputs= res['DistributionInputs']
            ctrl.distInputs = res['ColHeaders'];
            ctrl.inputTypeLt = res['radioOrCheckbox'];
            ctrl.multipleImpactLimit = res['multipleImpactLimit'] ? Number(res['multipleImpactLimit']) : 3;
            ctrl.npvData = res['npvSwingData'];
            ctrl.distInputs.map(function (d) {
                var item = ctrl.headersData.find(function (n) { return n.name === d.actionName; });
                if (item) {
                    item.count += 1;
                }
                else {
                    ctrl.headersData.push({ name: d.actionName, count: 1 });
                }
                ctrl.selectedControls.push({ "key": d.key, "display": d.display });
            });
            ctrl.issueConfig = ctrl.utilsService.getIssueConfig(res['CanvasConfig']);
            // Iterate objects
            Object.keys(sortedResData_1).forEach(function (key) {
                ctrl.populateItemList(key, sortedResData_1[key]);
            });
            ctrl.$timeout();
            ctrl.$scope.$apply();
        }
        else {
            ctrl.showAlert('danger', 'Error!', res.message);
        }
    };
    LtUncertainAltComponent.prototype.saveDFV = function () {
        var ctrl = this;
        // if (!ctrl.duplicateExists()) {
        // latest
        var req = {};
        ctrl.defaultSt.forEach(function (x) {
            // Init if array not exist
            if (!req[x.type])
                req[x.type] = [];
            req[x.type].push(x);
        });
        // old
        var temp = __spreadArray([], ctrl.defaultSt, true);
        var dArray = [];
        var fArray = [];
        var vArray = [];
        var aArray = [];
        var sArray = [];
        var wArray = [];
        var oArray = [];
        var tArray = [];
        temp.map(function (item) {
            if (item.type == 'desirability') {
                dArray.push(item);
            }
            else if (item.type == 'feasibility') {
                fArray.push(item);
            }
            else if (item.type == 'viability') {
                vArray.push(item);
            }
            else if (item.type == 'strengths') {
                sArray.push(item);
            }
            else if (item.type == 'weaknesses') {
                wArray.push(item);
            }
            else if (item.type == 'opportunities') {
                oArray.push(item);
            }
            else if (item.type == 'threats') {
                tArray.push(item);
            }
            else if (item.type == 'sticky') {
                aArray.push(__assign(__assign({}, item), { type: 'default' }));
            }
        });
        var dataGot = {
            addStickies: aArray,
            desirability: dArray,
            feasibility: fArray,
            viability: vArray,
            strengths: sArray,
            weaknesses: wArray,
            opportunities: oArray,
            threats: tArray
        };
        //compariison
        console.log(req);
        console.log(dataGot);
        ctrl.$timeout(function () {
            ctrl.smartorg.saveImpactMappingData(ctrl.node._id, req).then(function (res) {
                if (res) {
                    ctrl.$timeout();
                    ctrl.$scope.$apply();
                    ctrl.showAlert('success', 'Success!', 'Changes saved successfully.');
                }
                else {
                    ctrl.showAlert('danger', 'Error!', res.message);
                }
            })["catch"](function (err) {
                ctrl.showAlert('danger', 'Error!', err.message);
            });
        }, 500);
        // }
    };
    return LtUncertainAltComponent;
}());
exports.LtUncertainAltComponent = LtUncertainAltComponent;
angular.module('smartorg.r6.acts.ltUncertainAlt', []).component('ltUncertainAlt', {
    template: require('./lt-uncertain-alt.component.html'),
    controller: LtUncertainAltComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.ltUncertainAlt';
//# sourceMappingURL=lt-uncertain-alt.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/lt-uncertain-alt/lt-uncertain-alt.component.js